
export const BottomNav = () => `
    <nav id="bottom-nav">
        <button class="nav-item active" data-target="home">
            <span class="icon">🏠</span>
            <span class="label">Ana Sayfa</span>
        </button>
        <button class="nav-item" data-target="music" onclick="if(window.MusicWidget) window.MusicWidget.elements.modal.classList.remove('hidden'); window.MusicWidget.syncUI()">
            <span class="icon">🎵</span>
            <span class="label">Müzik</span>
        </button>

        <button class="nav-item" data-target="menu" onclick="if(window.SidebarManager) window.SidebarManager.toggle(true)">
            <span class="icon">☰</span>
            <span class="label">Menü</span>
        </button>
        <button class="nav-item" data-target="settings" onclick="if(window.SettingsManager) window.SettingsManager.openSettings()">
            <span class="icon">⚙️</span>
            <span class="label">Ayarlar</span>
        </button>
    </nav>
`;
